/**
 * Bridge to the BB Mac app (desktop/macos). Its WKWebView has no web
 * Notification API or service-worker push, so the page hands new-message
 * alerts and the unread count to the app's `bbNotify` message handler, which
 * shows them in macOS Notification Center and on the Dock icon. Every helper
 * is a no-op in an ordinary browser.
 */

type MessageHandler = { postMessage: (message: unknown) => void };

function handler(): MessageHandler | null {
  if (typeof window === "undefined") return null;
  return (window as any).webkit?.messageHandlers?.bbNotify ?? null;
}

export const isNativeMacApp = (): boolean => handler() !== null;

/** A macOS notification. Clicking it focuses the app and dispatches `event`
 *  (with `detail`) on window — e.g. "openChatRoom" with { roomId }. */
export function nativeNotify(n: { title: string; body?: string; tag?: string; event?: string; detail?: Record<string, unknown> }): void {
  const h = handler();
  if (!h) return;
  // Only when the user isn't already looking at BB — the in-page toast covers that.
  if (!document.hidden && document.hasFocus()) return;
  try { h.postMessage({ type: "notify", ...n }); } catch { /* app without the handler */ }
}

/** Unread count on the Dock icon (0 clears it). */
export function nativeBadge(count: number): void {
  try { handler()?.postMessage({ type: "badge", count }); } catch { /* app without the handler */ }
}
